import React, { KeyboardEventHandler } from 'react';
import styles from './Clickable.module.scss';

type Props = {
  children: React.ReactNode;
  event: (e: any) => void;
  inline?: boolean;
  label: string;
  space?: boolean;
  disable?: boolean;
  cursor?: boolean;
}

const Clickable: React.FC<Props> = ({
  children,
  event,
  inline = true,
  label,
  space = true,
  disable = false,
  cursor = true,
}) => {
  const emitEvent = (e: any) => {
    if (disable) {
      return;
    }
    event(e);
  };
  const onKeyUp: KeyboardEventHandler = (e) => {
    if (e.keyCode === 13) {
      emitEvent(e);
    }
  };
  return (
    <div
      className={`${styles.clickable} ${space ? styles.space : ''} ${cursor ? styles.cursor : ''}`}
      style={{ display: inline ? 'inline-block' : 'block' }}
      onClick={emitEvent}
      onKeyUp={onKeyUp}
      role="button"
      aria-disabled={disable}
      tabIndex={0}
      aria-label={label}
    >
      {children}
    </div>
  );
};

export default Clickable;
